import { REVALIDATE_TIME } from "@/constants/cache"
import { TAMDA_MEDIA_SETTING_PATH } from "@/constants/path-api"
import httpClient from "@/lib/http-client"
import { TamdaMediaSettingData, TamdaMediaSettingResponse } from "@/types/types"

const TAMDA_MEDIA_COMMON_FIELDS = [
  "phoneNumber",
  "tagline",
  "facebook",
  "twitter",
  "linkedIn",
  "hotline",
  "email",
  "advertisingEmail",
  "youtube",
] as const

const TAMDA_MEDIA_META_QUERY = {
  fields: ["updatedAt"],
  populate: {
    websiteInfor: {
      fields: ["websiteName", "websiteKeyworlds", "websiteDescription"],
    },
    websiteMetaImage: {
      fields: ["url", "width", "height", "alternativeText"],
    },
    favicon: {
      fields: ["url"],
    },
    websiteFavicon: {
      fields: ["url"],
    },
    headerLogo: {
      fields: ["url"],
    },
    footerLogo: {
      fields: ["url"],
    },
  },
} as const

export const fetchTamdaMediaSetting = async (): Promise<TamdaMediaSettingData | null> => {
  try {
    const response = await httpClient.get<TamdaMediaSettingResponse | { data: TamdaMediaSettingData[] }>(
      `/${TAMDA_MEDIA_SETTING_PATH}`,
      {
        fields: [...TAMDA_MEDIA_COMMON_FIELDS],
        populate: {
          headerLogo: { fields: ["url"] },
          footerLogo: { fields: ["url"] },
        },
      },
      {
        next: {
          revalidate: REVALIDATE_TIME,
          tags: ["tamdamedia_settings"],
        },
      },
    )

    if (Array.isArray(response?.data)) {
      return response.data[0] || null
    }
    return (response as TamdaMediaSettingResponse)?.data || null
  } catch (error) {
    console.error("Failed to fetch tamda media setting:", error)
    return null
  }
}

export const getTamdaMediaSettingData = async () => {
  try {
    const response = await httpClient.get(`/${TAMDA_MEDIA_SETTING_PATH}`, TAMDA_MEDIA_META_QUERY, {
      next: {
        revalidate: REVALIDATE_TIME,
        tags: ["tamdamedia_settings_meta"],
      },
    })
    return (response as any).data
  } catch (error) {
    console.error("Error fetching Tamda Media Settings for Metadata:", error)
    return null
  }
}

export const fetchTamdaMediaScriptSettings = async (): Promise<{
  headerScripts?: string | null
  bodyScript?: string | null
  GoogleAnalyticsTrackingID?: string | null
} | null> => {
  try {
    const response = await httpClient.get(
      `/${TAMDA_MEDIA_SETTING_PATH}`,
      { fields: ["headerScripts", "bodyScript", "GoogleAnalyticsTrackingID"] },
      { next: { revalidate: REVALIDATE_TIME, tags: ["tamdamedia_scripts"] } } as RequestInit,
    )
    const data = Array.isArray((response as any)?.data) ? (response as any).data[0] : (response as any)?.data
    return data?.attributes ?? null
  } catch (error) {
    console.error("Failed to fetch tamda media script settings:", error)
    return null
  }
}

